import React,{useContext} from 'react';
import {Route, Routes} from 'react-router-dom';
import asides from '../../routes/asideRoutes';
import AuthContext from '../../contexts/authContext';
const AsideRoutes = () => {
    const {user}=useContext(AuthContext)
    return (<Routes>
        {(user !== null && user !== false) && (
            <>{asides.map((page) => (
                // eslint-disable-next-line react/jsx-props-no-spreading
                <Route key={page.path} {...page}/>))}
            </>
        )}
        {user === null &&
            <Route path={"*"} element={<div></div>}/>}
    </Routes>);
}

export default AsideRoutes;
